import { createClient } from '@cms/i18n/shared';

import { I18N_NAMESPACES } from './namespaces';
import { I18N_RESOURCES } from './resources';

export const i18n = createClient({
    resources: I18N_RESOURCES,
    namespaces: I18N_NAMESPACES,
});
